module.exports = __webpack_public_path__ + "img/slick.f97e3bb.svg";